import { Button, ButtonTypes, isWeb } from 'fitbeat.react-native-components';
import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { ActivityIndicator, SafeAreaView, StyleSheet, Text, View } from 'react-native';
import { connect } from 'react-redux';
import FitillionIcon from '../assets/icons/fitillion.svg';
import { IAppStore } from '../HomeWorkouts';
import Theme from '../theme';
import { defaultScale, scaleText } from '../utils/scaling';
import UserDataConsumer from '../utils/UserDataConsumer';
import { acceptFamilyPlanInvitation, closeInvitationCodeWelcomeScreen } from './actions';
import {
  isAcceptingInvitationSelector,
  joinedFamilyPlanInformationSelector,
  userIsContinuingFromSignoutSelector,
  userJoinedFamilyPlanSuccessfullySelector,
} from './selector';
import InformationIcon from '../assets/icons/info.svg';

interface IProps {
  t: any;
  invitedByUser: string;
  automaticallyAcceptInvitation: boolean;
  successfullyJoined: boolean;
  isLoading: boolean;
  information: string;
  proceed: () => void;
  close: () => void;
  join: () => void;
}

class InvitationCodeWelcome extends Component<IProps> {
  constructor(props) {
    super(props);
  }

  public componentDidMount = () => {
    if (this.props.automaticallyAcceptInvitation) {
      this.props.join();
    }
  }

  public render() {
    const { t } = this.props;

    const renderJoinNow = () => (
      <View style={{flex: 1, justifyContent: 'space-between', marginTop: defaultScale(50)}}>
        <View style={styles.textContainer}>
          <Text style={styles.text}>
            <Text style={{ fontFamily: Theme.Weight700 }}>
              {this.props.invitedByUser}
            </Text>{' '}
            {t('familyPlan:invited')}.
          </Text>
        </View>
        <View>
          <View style={styles.mainActionConatainer}>
            <Button
              title={`Join ${this.props.invitedByUser} Now`}
              onPress={this.props.join}
              buttonType={ButtonTypes.NORMAL}
              contentContainerStyle={styles.mainAction}
              overrideFontStyles={styles.mainActionFontStyle}
            />
          </View>
          <Text onPress={this.props.close} style={styles.doNotJoin}>
              {t('familyPlan:doNotJoin')}
          </Text>
        </View>

      </View>
    );

    const renderCongratulations = () => (
      <View style={{flex: 1, justifyContent: 'space-between', marginTop: defaultScale(50)}}>
        <View style={styles.textContainer}>
          <Text style={styles.text}>
            {t('familyPlan:congratulations')}
          </Text>
          <Text style={styles.text}>{t('familyPlan:joined',
          { name: this.props.invitedByUser })}.</Text>
        </View>
        <View>
        {this.props.information.length > 0 &&
            <View style={styles.informationContainer}>
              <View style={styles.informationContent}>
                <InformationIcon
                  width={defaultScale(25)}
                  height={defaultScale(25)}
                />
                <Text style={styles.informationFontStyle}>{this.props.information}</Text>
              </View>
            </View>
            }
          <View style={styles.mainActionConatainer}>
            <Button
              title={t('familyPlan:letsGo')}
              onPress={this.props.proceed}
              buttonType={ButtonTypes.NORMAL}
              contentContainerStyle={styles.mainAction}
              overrideFontStyles={styles.mainActionFontStyle}
            />
          </View>
          </View>
      </View>
    );

    const renderFailure = () => (
      <View style={{flex: 1, justifyContent: 'space-between', marginTop: defaultScale(50)}}>
        <View style={styles.textContainer}>
          <Text style={styles.text}>
            {t('familyPlan:unableToJoin', { name: this.props.invitedByUser })}
          </Text>
        </View>
        <View>
          {this.props.information.length > 0 &&
            <View style={styles.informationContainer}>
              <View style={styles.informationContent}>
                <InformationIcon
                  width={defaultScale(25)}
                  height={defaultScale(25)}
                />
                <Text style={styles.informationFontStyle}>{this.props.information}</Text>
              </View>
            </View>
            }
          <View style={styles.mainActionConatainer}>
            <Button
              title={t('familyPlan:ok')}
              onPress={this.props.proceed}
              buttonType={ButtonTypes.NORMAL}
              contentContainerStyle={styles.mainAction}
              overrideFontStyles={styles.mainActionFontStyle}
            />
          </View>
          </View>
      </View>
    );

    const renderContent = () => {
      if (this.props.successfullyJoined === undefined) {
        return renderJoinNow();
      } else if (this.props.successfullyJoined) {
        return renderCongratulations();
      } else if (!this.props.successfullyJoined) {
        return renderFailure();
      }
    };

    return (
      <SafeAreaView style={styles.container}>
        {this.props.isLoading && (
          <ActivityIndicator
            size='small'
            color={Theme.PRIMARY}
            animating={true}
            style={styles.loader}
          />
        )}

        {!this.props.isLoading && (
          <View style={{flex: 1, paddingHorizontal: defaultScale(10)}}>
            <View style={styles.icon}>
              <FitillionIcon
                fill={Theme.BLACK}
                width={defaultScale(150)}
                height={defaultScale(150)}
              />
            </View>
            {renderContent()}
          </View>
        )}
      </SafeAreaView>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Theme.WHITE,
    paddingHorizontal: defaultScale(15),
  },
  icon: {
    marginTop: isWeb() ? defaultScale(20) : defaultScale(60),
    alignSelf: 'center',
  },
  mainActionConatainer: {
    marginBottom: defaultScale(20),
    marginTop: isWeb() ? defaultScale(30) : defaultScale(10),
  },
  mainAction: {
    borderColor: Theme.PRIMARY,
    borderRadius: defaultScale(5),
    alignItems: 'center',
  },
  mainActionFontStyle: {
    fontFamily: Theme.Weight700,
    fontSize: scaleText(16),
    color: Theme.WHITE,
  },
  textContainer: {
    marginTop: defaultScale(50),
  },
  text: {
    ...Theme.textStyle.heading,
    textAlign: 'center',
  },
  loader: {
    flex: 1,
    paddingVertical: defaultScale(20),
    alignItems: 'center',
  },
  doNotJoin: {
    textAlign: 'center',
    color: Theme.PRIMARY,
    marginBottom: defaultScale(20),
    fontFamily: Theme.Weight700,
    fontSize: scaleText(16),
  },
  informationContainer: {
    padding: defaultScale(15),
    backgroundColor: Theme.WHITE,
    borderWidth: 1,
    borderColor: Theme.GREY_MEDIUM_LIGHT,
    marginTop: isWeb() ? defaultScale(50) : defaultScale(30),
    marginBottom: defaultScale(20),
  },
  informationContent: {
    flexDirection: 'row'
  },
  informationFontStyle: {
    marginLeft: defaultScale(5),
    paddingRight: defaultScale(30),
    textAlign: 'left',
    fontFamily: Theme.Weight300,
    fontSize: scaleText(16),
  },
});

const mapStateToProps = (state: IAppStore): Partial<IProps> => {
  return {
    invitedByUser: state.deepLinkParamaters.referredByFullName,
    automaticallyAcceptInvitation: userIsContinuingFromSignoutSelector(state),
    successfullyJoined: userJoinedFamilyPlanSuccessfullySelector(state),
    isLoading: isAcceptingInvitationSelector(state),
    information: joinedFamilyPlanInformationSelector(state),
  };
};

const mapDispatchToProps = (dispatch: any, ownProps: any) => {
  const navigation = ownProps.navigation;
  const userServiceClient = ownProps.user.userServiceClient;
  const setUpInitialUserData = ownProps.user.setUpInitialUserData;

  return {
    proceed: () => dispatch(closeInvitationCodeWelcomeScreen(navigation, setUpInitialUserData)),
    close: () => dispatch(closeInvitationCodeWelcomeScreen(navigation, setUpInitialUserData)),
    join: () => dispatch(acceptFamilyPlanInvitation(userServiceClient)),
  };
};

const invitationCodeWelcomeState = UserDataConsumer(
  connect(mapStateToProps, mapDispatchToProps)(InvitationCodeWelcome),
);
export default translate(['familyPlan'], { wait: true })(invitationCodeWelcomeState);
